import React, { forwardRef } from "react";
import cx from "classnames";
import styled from 'styled-components';
import IBuildrProps from '../../utilities/IBuildrProps';

const initialScore = 100;
function getTextGrade(score): { letterGrade: string, symbol: string} {
    let letterGrade = 'F';
    let symbol = '';

    if (score >= 90) {
        letterGrade = 'A';
    } else if (score >= 80) {
        letterGrade = 'B';
    } else if (score >= 70) {
        letterGrade = 'C';
    } else if (score >= 60) {
        letterGrade = 'D';
    }

    if (letterGrade === 'F') {
        return { letterGrade, symbol };
    }

    const remainder = score % 10;
    if (score == 100 || remainder >= 7) {
        symbol = '+';
    } else if (remainder <= 2) {
        symbol = '-';
    }
    return { letterGrade, symbol };
};

interface IChecklistItemModalProps extends IBuildrProps {
    tabId: number;
    selections: any[],
    totalItems: number;
}

export default styled(forwardRef(({ cmsId, className, editorClassObj, tabId, selections, totalItems }: IChecklistItemModalProps, ref: any) => {
    const tabSelections = selections.filter(s => s.tabId === tabId);
    const score = tabSelections.reduce((acc, curr) => {
        if (curr.fail) {
            acc -= curr.points || 0;
        }
        return Math.max(acc, 0);
    }, initialScore);

    const { letterGrade, symbol } = getTextGrade(score);

    return (
        <div data-id={cmsId} ref={ref} className={cx(editorClassObj, className, `grade-${letterGrade}`)}>
            <div className="inner">
                <h3 className="grade">{`${letterGrade}${symbol}`}</h3>
                <span className="progress">
                    {tabSelections.length ?
                        `Progress: ${tabSelections.length}/${totalItems}`
                        :
                        "Every car starts with an \"A+\" grade, but check the boxes that apply and we'll see if it makes the grade."
                    }
                </span>
            </div>
        </div>
    );
}))`
background: #5BAE04;
bottom: 0px;
color: #fff;
left: 0;
padding: 15px;
position: fixed;
font-size: 16px;
width: 100%;
z-index: 1000;
float: left;
vertical-align: middle;
margin: 0px 0 0;
opacity: 0.95;
font-weight: 700;
transition: all 2s;

&.grade-A {
    background-color: #5BAE04;
}
&.grade-B {
    background-color: #B9DF20;
}
&.grade-C {
    background-color: #F7B500;
}
&.grade-D {
    background-color: #f77404;
}
&.grade-F {
    background-color: #E02020;
}

.inner {
    text-align: left;
    width: 920px;
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
}
.grade {
    margin-bottom: 0;
    margin-right: 50px;
    font-size: 2.375rem;
    font-family: ${props => props.theme.fontFamilySerif};
}
.progress {
    font-size: 1.1rem;
}
`;
